import { render, staticRenderFns } from "./Planta.vue?vue&type=template&id=8165680a&scoped=true&lang=pug&"
import script from "./Planta.vue?vue&type=script&lang=js&"
export * from "./Planta.vue?vue&type=script&lang=js&"
import style0 from "./Planta.vue?vue&type=style&index=0&id=8165680a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8165680a",
  null
  
)

export default component.exports